import {observable} from "mobx"
import OfferFieldValueSource from "../class/value_source/OfferFieldValueSource"
import {IS_EMPTY} from "../constant/ValueSourceType";

class ProfileOfferSettings {
    fields = {}

    init(fields) {
        for (const fieldsKey in fields) {
            if (fields.hasOwnProperty(fieldsKey)) {
                const field = fields[fieldsKey]
                this.fields[fieldsKey] = new Field(field)
            }
        }
    }

    getFieldsValues() {
        const values = {}
        for (const fieldsKey in this.fields) {
            if (this.fields.hasOwnProperty(fieldsKey)) {
                const field = this.fields[fieldsKey]
                values[fieldsKey] = {
                    value: field.value,
                    markups: field.markups,
                    additional_price: field.additional_price,
                    additional_price2: field.additional_price2,
                    additional_price_currency2: field.additional_price_currency2,
                    additional_price_currency: field.additional_price_currency,
                    strip_tags: field.strip_tags,
                    unit: field.unit,
                    is_validate: field.is_validate
                }
            }
        }
        return values
    }

}

class Field {

    /** @type {OfferFieldValueSource} */
    @observable value
    @observable strip_tags
    @observable is_validate
    @observable markups
    conditions
    type
    not_conditions
    required
    name
    tag
    hint
    parent
    dataset

    constructor(data) {
        for (const key in data) {
            if (data.hasOwnProperty(key)) {
                if (key === "value" || key === "markups") continue
                this[key] = data[key]
            }
        }
        this.value = new OfferFieldValueSource(data['value'])
        if (this.type && this.type === 'PRICE') {
            this.markups = [];
            for (const markup of data['markups']) {
                const theMarkup = {};
                for (const datumElementKey in markup) {
                    theMarkup[datumElementKey] = new OfferFieldValueSource(markup[datumElementKey]);
                }
                this.markups.push(theMarkup);
            }
        }

        if (this.type && this.type === 'WEIGHT') {
            this.unit = new OfferFieldValueSource(data['unit'])
        }
    }

    isConditionsMet() {
        if (!this.conditions && !this.not_conditions) {
            return true
        }
        if (this.conditions) {
            for (const fieldName in this.conditions) {
                if (this.conditions.hasOwnProperty(fieldName)) {
                    const field = profileOfferSettings.fields[fieldName]
                    if (!field) {
                        continue
                    }
                    const condition = this.conditions[fieldName]
                    for (const conditionElement of condition) {
                        if (field.value) {
                            if (field.value.source_value === conditionElement) {
                                if (field.isConditionsMet()) {
                                    return true
                                }
                            }
                        }
                    }
                }
            }
        }
        if (this.not_conditions) {
            for (const fieldName in this.not_conditions) {
                if (this.not_conditions.hasOwnProperty(fieldName)) {
                    const field = profileOfferSettings.fields[fieldName]
                    if (!field) {
                        continue
                    }
                    const condition = this.not_conditions[fieldName]
                    for (const conditionElement of condition) {
                        if (field.value) {
                            if (field.value.source_value === conditionElement) {
                                return false
                            }
                        }
                    }
                }
            }
            return true
        }
        return false

    }

    addMarkup() {
        this.markups.push({
            from: new OfferFieldValueSource({source_value: "", source_type: IS_EMPTY}),
            to: new OfferFieldValueSource({source_value: "", source_type: IS_EMPTY}),
            additional_price: new OfferFieldValueSource({source_value: "", source_type: IS_EMPTY}),
            additional_price2: new OfferFieldValueSource({source_value: "", source_type: IS_EMPTY}),
            additional_price_currency: new OfferFieldValueSource({source_value: "", source_type: IS_EMPTY}),
            additional_price_currency2: new OfferFieldValueSource({source_value: "", source_type: IS_EMPTY})

        });
    }
    deleteMarkup(index) {
        this.markups.splice(index, 1);
    }
}

const profileOfferSettings = new ProfileOfferSettings()

export default profileOfferSettings